<template>
  <div>
    <div class="content-header">
    
      <div class="content-header-left">
        <div class="search">
          <vs-input icon-pack="feather" icon="icon-search" v-model="searchtxt" placeholder="Search by Name"
            class="is-label-placeholder" />
        </div>
      </div>
      <div class="content-header-right">
      <vs-inv-dropdown >
        <!-- <vs-dropdown  vs-custom-content vs-trigger-click>
          <vs-button
            color="primary"
            class="filter-btn"
            type="border"
            icon-pack="feather"
            icon="icon-chevron-down"
            icon-after
          >
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button> -->
          <!-- <vs-dropdown-menu ref="filter_menu" class="filters-content settings_filters"> -->
          <div class="filters-content">
            <div class="filters-form-fileds noscroll">
              <div class="form-container">
                <div class="vx-row">

                 <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Setup Status</label>
                    
                    <multiselect v-model="selected_config_completed_statusids" :options="all_config_status" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select Setup Status" label="name" track-by="name" :preselect-first="false">
                      <!-- <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                          options selected</span>
                      </template> -->
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Setup Status Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  
                 
                  <div class="vx-col md:w-1/3 w-full con-select" v-if="[1].indexOf(getUserRoleId)>-1">
                    <label class="typo__label">Select  Customers</label>
                    
                   
                          <multiselect
                          v-model="filteredTenants"
                          :options="tenantsList"
                          :multiple="true" :hideSelected="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="Select Customers"
                          label="name"
                          track-by="_id"
                          :preselect-first="false"
                          > 
                          <template slot="selection" slot-scope="{ values, isOpen }">
                            <span
                            class="multiselect__selectcustom"
                            v-if="values.length && !isOpen"
                            >{{ values.length }} Customer(s) Selected</span
                            >
                            <span
                            class="multiselect__selectcustom"
                            v-if="values.length && isOpen"
                            ></span>
                          </template>
                          </multiselect>
            
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Status</label>
                    
                    <multiselect v-model="selected_statusids" :options="all_status" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select Status" label="name" track-by="name" :preselect-first="false">
                      <!-- <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                          options selected</span>
                      </template> -->
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Status Selected</span
                          >
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                          ></span>
                        </template>
                    </multiselect>
                  </div>
                   

                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Created Date</label>
                    <date-range-picker
                      :maxDate="new Date()"
                      :autoApply="autoApply"
                      :ranges="false"
                      v-model="selected_createdDateRange"
                    ></date-range-picker>
                  </div>
                 </div>
                   
                   
     
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons">

              </div>
              <div class="right-buttons">
                <vs-button color="success" class="save" type="filled" v-on:click="set_filter()">Apply</vs-button>
                <vs-button color="dark" class="cancel" type="filled" v-on:click="clear_filter($event)">Clear
                </vs-button>
              </div>
            </div>
          </div>
          <!-- </vs-dropdown-menu>
        </vs-dropdown> -->
      </vs-inv-dropdown>
          
        
        
        <!--<vs-button type="border" v-if="[1].indexOf(getUserRoleId)>-1" class="light-blue-btn" >
        <router-link v-if="[1 ,3 ].indexOf(getUserRoleId)>-1" :to="'/workflow-config'"> 
            Add  New     
         <span>
          <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
        </span>
        </router-link>
        </vs-button>-->
        
         <vs-button type="border" v-if="[1,3].indexOf(getUserRoleId)>-1" class="light-blue-btn" @click="createNew(true);">Add Workflow<span>
          <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
        </span>
        </vs-button>
        
      </div>
    </div>

    <NoDataFound ref="NoDataFoundRef"  :loading="!contentLoaded" v-if="list.length == 0" :content="callFromSerch?'':''" :heading="callFromSerch?'No Results Found':'No Workflow Found'" type='workflow' />
    <div class="accordian-table" v-if="list.length>0">
      <vs-table :data="list" >
        <template slot="thead" >
         <vs-th>
          <a @click="sortMe('name')"  v-bind:class="{'sort_ascending':sortKeys['name']==1, 'sort_descending':sortKeys['name']!=1}" >
             Name
              </a>
          </vs-th>
          <vs-th  v-if="filteredTenants.length>0" >
          

          <a @click="sortMe('tenantName')"  v-bind:class="{'sort_ascending':sortKeys['tenantName']==1, 'sort_descending':sortKeys['tenantName']!=1}" >
             Customer
              </a>
          
          </vs-th>
         <vs-th>Cases</vs-th>
          
      
          <vs-th>
          <a @click="sortMe('createdOn')"  v-bind:class="{'sort_ascending':sortKeys['createdOn']==1, 'sort_descending':sortKeys['createdOn']!=1}" >
             Created On
              </a>
          </vs-th>
          <vs-th>
          <a @click="sortMe('updatedOn')"  v-bind:class="{'sort_ascending':sortKeys['updatedOn']==1, 'sort_descending':sortKeys['updatedOn']!=1}" >
             Updated On
              </a>
          </vs-th>
          <!-------------->
           <vs-th>
           <a @click="sortMe('configCompleted')"  v-bind:class="{'sort_ascending':sortKeys['configCompleted']==1, 'sort_descending':sortKeys['configCompleted']!=1}" >
             Setup Status
              </a>
           
           </vs-th>
            <vs-th><a @click="sortMe('status')"  v-bind:class="{'sort_ascending':sortKeys['status']==1, 'sort_descending':sortKeys['status']!=1}" >
              Status
              </a></vs-th>
          <vs-th class="actions">Actions</vs-th>

        </template>

        <template slot-scope="{data}">
          <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.username" class="td_label">
              <!--
              <img class="user-image" src="@/assets/images/main/avatar2.svg" />
              -->
              {{tr.name }}
              
              <small v-if="checkProperty(tr , 'workflowType') !=''">({{tr.workflowType}})</small>
              <small v-if="checkProperty(tr , 'refId') !=''">(Global)</small>

              
            </vs-td>
            
             <vs-td  v-if="filteredTenants.length>0"><div class="td_text">{{checkProperty(tr ,'tenantDetails' ,'name')}}</div></vs-td>
             <vs-td >
             <span class="count"> {{checkProperty(tr , 'petitionCount' ) }}</span>
            </vs-td >
            <vs-td >{{tr.createdOn | formatDate }}</vs-td >
            <vs-td >{{tr.updatedOn | formatDate }}</vs-td >
            <vs-td >
              <span class="statusspan " :class="{'status_pending':!tr.configCompleted,'status_active':tr.configCompleted}" >
              
              </span>
              {{tr.configCompleted?"Complete":"Pending"}}
            </vs-td>

            <vs-td >
              <span class="statusspan " :class="{'status_pending':!tr.active,'status_active':tr.active}" >
              
              </span>
              {{tr.active?"Active":"Inactive"}}
              
            </vs-td>
           
            <vs-td >
              
             
              <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                  <a class="a-icon" href.prevent><more-vertical-icon size="1.5x" class="custom-class"></more-vertical-icon></a>
                 <vs-dropdown-menu class="loginx msg_dropdown">
                    <!-- <vs-dropdown-item>
                      <router-link  :to="'/workflow-config-view/'+tr._id">  <p style="cursor:pionter" >View</p></router-link>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <router-link v-if="[1 ,3 ].indexOf(getUserRoleId)>-1 && tr.petitionCount <=0" :to="'/workflow-config/'+tr._id">  <p style="cursor:pionter" >Edit</p></router-link>
                   </vs-dropdown-item> -->

        
                   <vs-dropdown-item @click=" showMe(tr)">View
                      <!-- <router-link  :to="'/workflow-config-view/'+tr._id">  <p style="cursor:pionter" >View</p></router-link> -->
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                    
                  <a href.prevent @click="editMe(tr)"   v-if="[1 ,3 ].indexOf(getUserRoleId)>-1 && tr.petitionCount <=0" >Edit</a>
                   </vs-dropdown-item>

                   

                   
                   <vs-dropdown-item>
                      <a  v-if="[1 ,3 ].indexOf(getUserRoleId)>-1" href.prevent @click="cloneMe(tr)"  >
                        Clone
                      </a>
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="[1 ,2,3 ].indexOf(getUserRoleId)>-1 && ( tr.configCompleted) && tr.petitionCount <=0">
                    <a  @click="openactivepopup(tr)"  >
                      {{ tr.active?'Inactivate':' Activate'}}
                    </a>
                    </vs-dropdown-item>
                  <vs-dropdown-item href.prevent v-if="[1 ,2].indexOf(getUserRoleId)>-1 && ( tr.configCompleted) && tr.active && tr.petitionCount <=0" >
                    <a   @click="openPetitionConfiguration(tr)"  >
                      Config Workflow
                      
                    </a>
                  </vs-dropdown-item>   
                   </vs-dropdown-menu>
                </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="table_footer">
        <div class="vx-col  con-select pages_select"  v-if="list.length>0">
          <label class="typo__label">Per Page</label>
          <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false"
              :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
              :preselect-first="true" :allow-empty="false">
            </multiselect>
            <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
          </div>
          <paginate  v-if="list.length>0"  v-model="page" :page-count="totalpages" :page-range="3" :margin-pages="2" :click-handler="pageNate"
        prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
        :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'"></paginate>
      </div>
      
    </div>


    
    

    <vs-popup class="holamundo main-popup" title="Delete form and letters" :active.sync="approveConformpopUp">
      <div class="form-container">
        
        <div class="vx-row">
          <div class="vx-col w-full">
          {{actionText}}
            
          </div>
          
        </div>
       
      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="approveConformpopUp=false">Cancel</vs-button>
        <vs-button color="success" class="save" type="filled" @click="deleteformandLetter()">Delete</vs-button>
      </div>
    </vs-popup>
    <vs-popup class="holamundo main-popup" :title="edit?'Edit Workflow':'Add Workflow'" v-if="addPopup" :active.sync="addPopup">
      <form>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group">
             <label class="form_label">Workflow Template<em>*</em></label>
            
              <div class="con-select">
                  <multiselect
                      name="workflowTemp"
                      v-model="selectedTemplate"
                      :options="workFlowTemplateList"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Workflow Template"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                      @input="getSelectedTemplateDetails"
                      v-validate="'required'"
                    > 
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span v-if="gettingTemplateDetails" class="loader"
                        ><img src="@/assets/images/main/loader.gif"
                       /></span>
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Customer(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>



              </div>
              <span class="text-danger text-sm" 
                    v-show="errors.has('workflowTemp')" >
                    Workflow Template is reqiured
                    </span>
              </div>
            </div>

            <div class="vx-col w-full">
              <div class="form_group">
                <label for class="form_label">Workflow Name<em>*</em></label>
                <vs-input :key="'WorkflowTitle'" @click="formerrors.msg=''" v-model="newform.name" name="Workflow Title" v-validate="'required'" class="w-full"
                data-vv-as="Workflow Name"    />
              <span class="text-danger text-sm"
                v-show="errors.has('Workflow Title')">{{ errors.first("Workflow Title") }}</span>
            </div>
             
               </div>  
            
          </div>

          <div class="form_group custom-radio_wrap">
           
            <ul class="custom-radio" vs-type="flex" vs-align="center">
              <li>
                
               <vs-radio  name="workflowType"  vs-value="Free-Flow" v-model="newform.workflowType" class="w-full"
                      ><span id="Free-Flow" ref="Free-Flow">Free-Flow</span></vs-radio > 

              
              </li>
                     <li>
          
                   <vs-radio :disabled="checkProperty(selectedTemplate, 'tplTypeId')==5"    ref="Sequential"  name="workflowType"  vs-value="Sequential"   v-model="newform.workflowType" class="w-full"
                      > <span id="Sequential" ref="Sequential">Sequential</span></vs-radio > 
              
                     </li>
                 
            </ul>
          </div>
           <div class="vx-row" v-if="[1].indexOf(getUserRoleId)>-1" >
            <div class="vx-col w-full">
              <div class="form_group">
             <label class="form_label">Customer</label>
            
              <div class="con-select">
                  <multiselect
                      v-model="selectedTenant"
                      :options="tenantsList"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Customer"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    > 
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Customer(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>



              </div>
              </div>
            </div>
          </div>


          <div class="text-danger text-sm formerrors" v-show="formerrors.msg" @click="formerrors.msg=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
        </div>
        <div class="popup-footer">
          <vs-button color="dark" @click="edit=false;createNew(false)" class="cancel" type="filled">Cancel</vs-button>
          <vs-button color="success"  :disabled="validateForm" class="save" v-if="edit" @click=" ConfigTemplate()" type="filled">Update</vs-button>
          <vs-button color="success" :disabled="gettingTemplateDetails" class="save" v-else @click=" createConfigTemplate()" type="filled">Save</vs-button>
        </div>
      </form>
    </vs-popup>

    <vs-popup class="holamundo main-popup" :title="'Clone Workflow'" v-if="clonePopup" :active.sync="clonePopup">
      <form>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <label class="form_label">Workflow Name<em>*</em></label>
              <vs-input :key="'WorkflowName'" @click="formerrors.msg=''" v-model="newform.name" placeholder="Workflow Name" name="Workflow Name" v-validate="'required'" class="w-full"
                  data-vv-as="Workflow Name"    />
              <span class="text-danger text-sm"
                v-show="errors.has('Workflow Name')">{{ errors.first("Workflow Name") }}</span>
            </div>
             
                 
            
          </div>

 
               <div class="vx-row">
           

                  <div class="vx-col">

                    <ul class="custom-radio d-flex">
                      <li class="mr-5"><vs-radio    name="workflowType"  vs-value="Free-Flow" v-model="newform.workflowType" class="w-full"
                      >Free-Flow</vs-radio > </li>
                      <li><vs-radio    name="workflowType"  vs-value="Sequential"   v-model="newform.workflowType" class="w-full"
                      >Sequential</vs-radio ></li>
                    </ul>
              
              
               

              
                  </div>
                    
                 
            
          </div>



                

          <div class="vx-row" v-if="[1].indexOf(getUserRoleId)>-1" >
            <div class="vx-col w-full">
              <div class="form_group">
             <label class="form_label">Customer</label>
            
              <div class="con-select">
                  <multiselect
                      v-model="selectedTenant"
                      :options="tenantsList"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Customer"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    > 
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Customer(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>



            </div>
              </div>
            </div>
          </div>


          <div class="text-danger text-sm formerrors mt-0" v-show="formerrors.msg" @click="formerrors.msg=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
        </div>
        <div class="popup-footer">
          <vs-button color="dark" @click="createNew(false)" class="cancel" type="filled">Cancel</vs-button>
          <vs-button color="success" :disabled="validateForm || creatingWorkFlow" class="save"  @click=" cloneTemplate()" type="filled">Clone</vs-button>
        </div>
      </form>
    </vs-popup>

    <vs-popup class="holamundo main-popup" :title="(checkProperty(selectedItem,'active')?'Inactivate ':' Activate')+' Workflow'" v-if="activatePopUp"   :active.sync="activatePopUp" >
      <div class="form-container">
        
        <div class="vx-row">
          <div class="vx-col w-full">
          <p>Are you sure of {{checkProperty(selectedItem ,'active')?'In ':''}}activating this workflow?</p>
           
          </div>
          
        </div>
       
      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="activatePopUp=false">Cancel</vs-button>
        <vs-button color="success" class="save" type="filled" @click="activateTemplate()">{{checkProperty(selectedItem,'active')?'Inactivate ':' Activate'}}</vs-button>
      </div>
    </vs-popup>

    
    <vs-popup class="holamundo main-popup" :title="'Workflow Case Configuration'" v-if="configPopup"   :active.sync="configPopup" >
      <div class="form-container" @ckick="formerrors.msg =''">
        
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <label for class="form_label">Case Type</label>
                <multiselect name="Case Configuration"   v-model="selectedPetition" 
                      :multiple="false"
                      :show-labels="false"
                      :ref="'Case Configuration'" 
                      track-by="_id" 
                      label="name"
                      data-vv-as="Case Type"
                      placeholder="Select Case Type"
                      :options="tempPetitionTypeList"
                      :searchable="true"
                      :allow-empty="false">
                  </multiselect>
                </div>
            </div>
          </div>
          
        </div>

        <div class="text-danger text-sm form_info" v-show="formerrors.msg" @click="formerrors.msg=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
       
      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="configPopup=false;">Cancel</vs-button>
        <vs-button color="success" class="save" :disabled="selectedPetition ==null" type="filled" @click="workFlowconfigAction()">Save</vs-button>
      </div>
    </vs-popup>

    
  </div>
</template>

<script>
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import DateRangePicker from "vue2-daterange-picker";
  import Datepicker from "vuejs-datepicker-inv";
  import Paginate from "vuejs-paginate";
  import NoDataFound from "@/views/common/noData.vue";

import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

  import _ from "lodash";
  import { FormWizard, TabContent } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
   import moment from 'moment'
  import PhoneMaskInput from "vue-phone-mask-input";
  import JQuery from 'jquery'
  import { TheMask } from 'vue-the-mask'
  
import FileUpload from "vue-upload-component/src";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { MoreVerticalIcon } from 'vue-feather-icons';
  export default {
    computed:{
      validateForm(){
        if(
          (this.newform.name && this.newform.name.trim() !='' ) 
         
        
        ){

          return false;
        }else{
          return true;
        }

      },
      
    },
    components: {
      vsInvDropdown,
      DateRangePicker,
      VuePhoneNumberInput,
      Datepicker,
      Paginate,
      FileUpload,
      FormWizard,
      TabContent,
      PhoneMaskInput,
      TheMask,
      MoreVerticalIcon,
      NoDataFound
    },

    data: () => ({
      gettingTemplateDetails:false,
      workFlowTemplateList:[],
      selectedTemplate:null,
      selectedTemplateDetails:null,
      creatingWorkFlow:false,
      contentLoaded:false,
      tenantsList:[],
      selectedTenant:null,
      filteredTenants:[],
      finalFilteredTenants:[],
      callFromSerch:false,
      selectedPetition:null,
      configPopup:false,
      petitionTypeList:[], 
      tempPetitionTypeList:[],
      workFlowConfigDetails:[], 
      activatePopUp:false,
      all_status:[{"name":"Active" ,"id":true} ,{"name":"Inactive" ,"id":false}],
     all_active_status:[{"name":"Active" ,"id":true} ,{"name":"Inactive" ,"id":false}],
     all_config_status:[{"name":"Complete" ,"id":true} ,{"name":"Pending" ,"id":false}],
     selected_active_statusids:[],
     final_active_statusids:[],    

      
    selected_createdDateRange: ["", ""],
    autoApply: "",
        value:[],
        all_formTypes:[{"name":"Form" ,"id":"Form"},{"name":"Letter" ,"id":"Letter"} ],
        
      selectedItem:null,
      selectedStatus:2,
      actionText:"Do you want to Delete?",
      formerrors: {
        msg: ""
      },
      date: null,
      approveConformpopUp: false,
     
     newform: {name:'', workflowType:"Sequential",fields:[] ,sections:[]},
      list: [],
      addPopup: false,
      NewPetition: false,
      
     
      searchtxt: "",
      query: [],
      country_code: 231,
      all_statusids: [],
      selected_statusids: [],
      final_selected_statusids: [],
      filter_roleIds: [],
      final_filter_roleIds: [1,2,3,4,5,8,9,10,11,12],

      
      seleted_states: [],
      final_selected_states: [],
      locations: [],
      // locationIds
      final_selected_config_completed_statusids:[],
      selected_config_completed_statusids:[],
      
      
      date: "",
      date_range: [],
      page: 1,
      perPeges: [10,25,50,75,100],
      perpage: 25,
      totalCount:0,
      totalpages: 0,
      allQuestionnairefields:[],

     
      switch2:true,
      users_status:{},
      edit:false,
      sortKeys:{},
      sortKey:{},
      details:null,
      getMasterData:true,
      clonePopup: false,

         workflowDetails:null,
         isValied:false,
         activityList:[],
         finalActivity:[],
         userRolesList:[],
        
         editorsCount:0,
         watcherCount:0,
         includeCount:0,
         actionRequiredCount:0
    }),
    watch: {
      searchtxt: function (value) {
        let self =this;
      this.page = 1;
      clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
        self.getList(true);
      }, 900)
        
      }

    },
    methods: {
      changeperPage(){
        this.page= 1;
        this.getList(true)
      },
      getWorkFlowTemplateList(){
       let postData= {
          filters:{
            title: "",
            petitionTypeIds: []
          },
          getMasterData: false, 
          page: 1,
          perpage: 25,
          sorting: {
            path: "createdOn",
            order: -1
          }
	      }
        this.$store.dispatch("commonAction", {"data":postData ,"path":"/workflow/template-list"})
        .then((response)=>{
          this.workFlowTemplateList = response.list
          
        }).catch((error)=>{})
      },

      getSelectedTemplateDetails(){
        this.selectedTemplateDetails =null;
        this.newform.name ='';
        this.newform.workflowType ='Sequential';

        if(this.checkProperty(this.selectedTemplate,'_id')){
        let postData={
          workflowTplId:this.checkProperty(this.selectedTemplate,'_id')
        }
        this.gettingTemplateDetails = true
        this.$store.dispatch("commonAction", {"data":postData ,"path":"/workflow/template-details"})
        .then((response)=>{
          const $ = JQuery;
          this.selectedTemplateDetails = response
          // if(this.getTenantTypeId ==2){
          //   this.selectedTemplateDetails.config =  this.selectedTemplateDetails.config.filter(item => {
          //     return !(item.code === "REQUEST_PETITIONER_SIGN");
          //   });
          // }
          if(this.getTenantTypeId == 1){
            this.selectedTemplateDetails.config =  this.selectedTemplateDetails.config.filter(item => {
              return !(item.code === "DOC_SIGNER_LIST");
            });
          }
          this.gettingTemplateDetails = false ;
          this.newform.name  = this.checkProperty( this.selectedTemplateDetails ,'name');
         
          if(this.checkProperty( this.selectedTemplateDetails ,'workflowType') !='Sequential' ){
            this.newform.workflowType = 'Free-Flow';
           // $("#Free-Flow").trigger('click');
          }

          if(this.checkProperty(this.selectedTemplate, 'tplTypeId')==5){
            this.newform.workflowType ='Free-Flow';
           $("#Free-Flow").trigger('click');

          } 
         
          
          if(this.checkProperty( this.selectedTemplateDetails ,'config' ,'length')>0){
            this.activityList = [];//this.selectedTemplateDetails['config'];
            let user = this.gerUserData;
            _.forEach(this.selectedTemplateDetails['config'] , (item)=>{
             
             
              if(_.has(item , 'showError')){
                item['showError'] = false;
              }
              if(_.has(item , 'optional')){
                item['optional'] = false;
              }
            
              
            if(_.has( user,'tenantDetails') && (['CREATE_PETITION' ,"LCA_REQUEST"].indexOf(item['code'])>-1 ) ){
            if(_.has(user['tenantDetails'] ,"typeId") && user['tenantDetails']['typeId']  ==2){
                item['editors'] = [
                    {
                      roleId: 3,
                      roleName: "Admin",
                    },
                    {
                      roleId: 4,
                      roleName: "Branch Manager",
                    }

                    ];

              }
            }

            if(this.getTenantTypeId ===2 && item['editors'] && item['editors'].length>0){
              //roleId
              item['editors'] =_.filter(item['editors'] , (role)=>{
              return role['roleId'] !=50

              })

            }



              this.activityList.push(item);

            });
            
          }
          
         let _self =this;
          setTimeout(()=>{
           // Free-Flow  Sequential
           const elem = _self.$refs[_self.newform['workflowType']];
          elem.click();
          });
         
        }).catch((error)=>{
          this.gettingTemplateDetails = false
        })
      }
      },
       getenants() {
        let matcher = {};
        let query = {};
        query['page'] = 1;
        query['perpage'] = 10000;
         query['getMasterData'] = true;
        query['filters'] = matcher;
       

        this.$store
          .dispatch("getList",{data:query ,path:'/tenant/list'} )
          .then(response => {
            this.tenantsList = response.list;

          });
      },


      processPetitionTypes(){
       
        //workFlowConfigDetails
       // selectedPetition:null,
       // configPopup:false,
       // petitionTypeList:[], 
       // tempPetitionTypeList:[],

      },
      openPetitionConfiguration(item){
        this.formerrors.msg=''
       this.selectedItem = item;
       this.tempPetitionTypeList = this.petitionTypeList;
       this.selectedPetition =null;
       this.workFlowConfigDetails =null;
       this.configPopup =true;
      },

      workFlowconfigAction(){
         this.formerrors.msg ='';
         if(this.selectedPetition !=null){
           let postData  = {"workflowId": this.selectedItem['_id'], "petitionTypeId": this.selectedPetition['id'] };
           this.$store.dispatch("commonAction" ,{ data:postData, path:"/workflow/config-save"})
           .then((res)=>{
             this.showToster({message:res.message ,isError:false});
             this.selectedPetition =null;
             this.workFlowConfigDetails =null;
             this.configPopup =false;
            })
           .catch((err)=>{
             this.formerrors.msg = err
              this.showToster({message:err ,isError:true});
           });

         }
      },

      getPetitionTypeList(){
         let item ={
          matcher:{
              "searchString":'',
             // "petitionType":

          },   
          page:1,
          perpage: 100000000,
          category: "petition_types",
          getMasterData:true
          
        };

        this.$store
          .dispatch("getMasterData",item )
          .then(response => {
            let tempList =[];
            let lst = response.list;
            _.forEach(lst ,(item)=>{
              
              item = Object.assign(item ,{"showMe":true});
              tempList.push(item);
            });
            this.petitionTypeList = tempList;
           
          });
      },
       openactivepopup(item){
         this.selectedItem = item;
        this.activatePopUp =true;
        this.edit= false;
      },
       activateTemplate(){
         let action =true;
         //alert(JSON.stringify(this.selectedItem));
         if(this.selectedItem['active'] ){
           action = false;
         }else{
           action =true;
         }
        let postData = {workflowId:this.selectedItem['_id'] ,"active":action};
        this.$store.dispatch("commonAction" ,{"data":postData , "path":"/workflow/manage-active-status"})
        .then((res)=>{
          this.activatePopUp = false;
          this.showToster({message:res.message ,isError:false});
          this.getList();

        })
        .catch((err)=>{

           this.showToster({message:err ,isError:true});
        })
      },

      processData(){
            
          let _self =this;
            this.finalActivity =[];  
            this.editorsCount=0;
            this.watcherCount=0;
            this.includeCount = 0;
            this.actionRequiredCount = 0;

             let submitTolawFrimEditors =[
                    {
                    "roleId":3,
                    "roleName":"Admin"
                    },

                     {
                        "roleId":4,
                        "roleName":"Branch Manager"
                    },
                    {
                    "roleId":5,
                    "roleName":"Front Office User"
                    },
              ];

               let submitTolawFrimWatchers =[
                    {
                    "roleId":3,
                    "roleName":"Admin"
                    },
                     {
                        "roleId":4,
                        "roleName":"Branch Manager"
                    }
              ];
           
            _.forEach(this.activityList, (item, index) => {
        let tempItem = {
          code: item.code,
          // "parentCode": "",
          name: item.name,
          editors: [],
          watchers: [],
          include: "No",
          actionRequired: "No",
        };
        if ( [  "CREATE_PETITION", "SUBMIT_BY_BENEFICIARY",  "SUBMIT_TO_LAW_FIRM","LCA_REQUEST" ,"DOC_SIGNER_LIST" ].indexOf(item.code) > -1   ) {
        

          if((_self.getTenantTypeId ==2 ) || ( _self.checkProperty(_self.selectedTenant ,'typeId') ==2   ) ){


            if (["DOC_SIGNER_LIST"].indexOf(item.code) > -1) {
              tempItem["editors"] =  item['editors'] = [{ roleId: 12, roleName: "Authorized Signatory" }];
              tempItem["actionRequired"] = item['actionRequired'] = "Yes";
               tempItem["watchers"] = [];
               tempItem["showMe"] =  item['showMe'] =true;
            }
              
            
          
            if (["CREATE_PETITION"].indexOf(item.code) > -1) {
              tempItem["editors"] = item['editors'] = [{ roleId: 3, roleName: "Admin" }, { roleId: 4, roleName: "Branch Manager" }];
              tempItem["actionRequired"] = item['actionRequired'] = "Yes";

              tempItem["watchers"] = item['watchers'] = submitTolawFrimWatchers
            
            }
            if (["SUBMIT_BY_BENEFICIARY"].indexOf(item.code) > -1) {
              tempItem["editors"] =  item['editors'] = [{ roleId: 51, roleName: "Beneficiary" }];
              tempItem["actionRequired"] = item['actionRequired'] = "Yes";
               tempItem["watchers"] = item['watchers'] = submitTolawFrimWatchers
            }

          
            if (["SUBMIT_TO_LAW_FIRM","LCA_REQUEST"].indexOf(item.code)>-1) {
              tempItem["editors"]=  item['editors'] =submitTolawFrimEditors;
              tempItem["actionRequired"] = item['actionRequired'] = "Yes";
              tempItem["watchers"] = item['watchers'] = submitTolawFrimWatchers
             
            }
          }else{

            if (["DOC_SIGNER_LIST"].indexOf(item.code) > -1) {
              tempItem["editors"] =  item['editors'] = [{ roleId:50, roleName: "Petitioner" }];
              tempItem["actionRequired"] = item['actionRequired'] = "Yes";
               tempItem["watchers"] =item['watchers'] = [];
               tempItem["showMe"] =  item['showMe'] =false;
            }

            if (["CREATE_PETITION"].indexOf(item.code) > -1) {
              tempItem["editors"] = item['editors'] = [{ roleId: 50, roleName: "Petitioner" }];
              tempItem["actionRequired"] = item['actionRequired'] = "Yes";
            }
            if (["SUBMIT_BY_BENEFICIARY"].indexOf(item.code) > -1) {
              tempItem["editors"] =  item['editors'] = [{ roleId: 51, roleName: "Beneficiary" }];
              tempItem["actionRequired"] = item['actionRequired'] = "Yes";
            }


            if (["SUBMIT_TO_LAW_FIRM" ].indexOf(item.code) > -1) {
              tempItem["editors"]=  item['editors'] = [{ roleId: 50, roleName: "Petitioner" }];
              tempItem["actionRequired"] = item['actionRequired'] = "Yes";
            }

          }



          if (item.include) {
            tempItem.include = "Yes";
           
          }
          if (item["watchers"].length > 0) {
            tempItem["watchers"] = item["watchers"];
           
          }

        } else {

        if((_self.getTenantTypeId ==2 ) || ( _self.checkProperty(_self.selectedTenant ,'typeId') ==2   ) ){
          if (["FILING_FEE" ,'PAYMENT_INTEGRATION'].indexOf(item.code) > -1) {
                item.actionRequired=false;
                item.include =false;

          }
          
        }

          if (_.has(item, "parentCode")) {
            tempItem.parentCode = item["parentCode"];
          }

          if (item.include) {
            tempItem.include = "Yes";
            this.includeCount++;
          }
          if (item.actionRequired) {
            tempItem.actionRequired = "Yes";
            this.actionRequiredCount++;
          }
          if (item["editors"].length > 0) {
            this.editorsCount++;
            tempItem["editors"] = item["editors"];
          }
          if (item["watchers"].length > 0) {
            tempItem["watchers"] = item["watchers"];
            this.watcherCount++;
          }
        }

        this.finalActivity.push(tempItem);
      });    

           return true;

            

           
           

      },
      getActivityList(){
        
            this.$store.dispatch("getActivityCodes")
            .then(response => {
            
                this.activityList = response;
                
            })
        .catch(error => {
            

        })
      },
     
       sortMe(sort_key=''){

      
        if(sort_key !=''){
            this.sortKeys[sort_key] = this.sortKeys[sort_key]==1?-1:1
            // this.sortKey[sort_key] = this.sortKeys[sort_key]
            this.sortKey = {"path":sort_key ,"order":this.sortKeys[sort_key]};
            

            localStorage.setItem('workflow_sort_key', sort_key);
            localStorage.setItem('workflow_sort_value', this.sortKey[sort_key]);
            this.getList();
        }
          
      

      },
      showMe(item) {
        this.$emit("showMe",item );

      },
      editMe(item){
        this.$emit("editMe",item );
        /*
        Object.assign(this.formerrors, {
                    msg:''
                  });
        this.edit =true;
        this.selectedItem = item;
        this.newform = {name:this.selectedItem.name }
        this.addPopup=true;
        this.clonePopup =false;
        */
        

      },

      cloneMe(item){
         this.creatingWorkFlow =false;
        this.selectedTenant =null;
        if(_.has(item ,'tenantDetails')  && _.has(item['tenantDetails'] ,"name") &&  _.has(item['tenantDetails'] ,"_id") ){
          this.selectedTenant = item['tenantDetails'];
        }
        Object.assign(this.formerrors, {
                    msg:''
                  });
        this.edit =false;
        this.selectedItem = item;
        this.newform = {
          name:this.selectedItem.name , "workflowType":"Free-Flow", // 'Sequential'
        };

      if(this.selectedItem['workflowType'] =="Sequential"){
        this.newform['workflowType'] = "Sequential";
      }
        this.addPopup=false;
         this.clonePopup =true;
         //alert(this.clonePopup )
        

      },
      cloneTemplate(){
        this.$validator.validateAll().then(result => {
          if (result) {
            let postData = {"name":this.newform['name']  ,"workflowId":this.selectedItem['_id'] ,"workflowType":"Free-Flow", };

            if(this.newform['workflowType'] =="Sequential"){
              postData['workflowType'] = "Sequential";
            }
            postData['name'] = postData['name'].trim();

            if(this.selectedTenant && _.has( this.selectedTenant ,"_id")){
              postData =Object.assign( postData ,{ "tenantId":this.selectedTenant['_id'] })
            }
            this.creatingWorkFlow =true;
            this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/workflow/clone"})
              .then(response => {
                  this.creatingWorkFlow =false;
                  Object.assign(this.formerrors, {
                    msg:''
                  });
                 this.showToster({message:response.message,isError:false });
                  if(this.selectedTenant && _.has( this.selectedTenant ,"_id")){
                                    
                    this.searchtxt ='';
                    this.filteredTenants =[];
                    this.finalFilteredTenants =[];
                    this.final_active_statusids = [];
                    this.selected_active_statusids =[];
                    this.selected_statusids = [];
                    this.final_selected_statusids = [];
                    this.final_selected_config_completed_statusids = [];
                    this.selected_config_completed_statusids = [];
                  
                    this.date = "";
                    this.date_range = [];
                    this.selected_createdDateRange["startDate"] = "";
                    this.selected_createdDateRange["endDate"] = "";
                     this.filteredTenants.push(this.selectedTenant);
                    this.finalFilteredTenants.push(this.selectedTenant['_id'])
                    


                 }
                    this.getList();
                 
                
                 this.addPopup =false;
                 this.edit =false;
                 this.clonePopup =false
                 this.createNew(false);
                                
                
              })
              .catch((error)=>{
                this.creatingWorkFlow =false;
                Object.assign(this.formerrors, {
                    msg:error
                  });
              })
          }
        });

      },     
     createNew(action =true){
      this.creatingWorkFlow =false;
       Object.assign(this.formerrors, {
                    msg:''
                  });
       this.selectedTenant =null;
       this.edit =false;
       this.clonePopup =false;
       this.newform = {name:'',workflowType:"Sequential", fields:[] ,sections:[]};
      this.addPopup=action;
      if( this.addPopup){
        this.getWorkFlowTemplateList();
      }
     
      this.selectedTemplate=null;
      this.selectedTemplateDetails=null;
      this.gettingTemplateDetails=false 
      
      //this.$router.push("/questionnaire-config-add");
     },
      
      deleteConform(item ){
        this.selectedItem = item;
        this.approveConformpopUp =true;
        this.edit= false;

      },
  
      getList(callFromSerch=false) {
       this.callFromSerch = callFromSerch;
       if(this.callFromSerch){
         
          this.list =[];
        }

       this.contentLoaded  = false;
       this.updateLoading(true);
         let item ={
          filters:{
              "title":this.searchtxt.trim(),
             "createdDateRange":[],
             //"statusList": this.final_selected_statusids, 
             "activeList":this.final_selected_statusids, // this.final_active_statusids,
            "configList":this.final_selected_config_completed_statusids,
            "tenantIds":this.finalFilteredTenants

          },
          getMasterData:false,   
          page:this.page,
          perpage: this.perpage,
          sorting:this.sortKey,
          //getMasterData:this.getMasterData          
        };

         if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        item['filters']["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"]
        ];
      }
     // alert(JSON.stringify(item));

        this.$store
          .dispatch("getList",{"data":item ,"path":"/workflow/list"} )
          .then(response => {
            this.list = response.list;
              this.contentLoaded  = true;
              this.updateLoading(false);
              this.totalCount = this.checkProperty(response,'totalCount')
            this.totalpages = Math.ceil(response.totalCount / this.perpage);
            //alert(this.perpage);
          }).catch(()=>{
            this.list =[];
            this.updateLoading(false);
             this.contentLoaded  = true;

          })
      },
      
       createConfigTemplate() {

        
        this.$validator.validateAll().then(result => {
          if (result && this.processData()) {
               let finalActivity =[];
              _.forEach(this.finalActivity ,(item)=>{
                if(item['code'] === "COLLECT_ADV_EVIDENCE"  ){
                  if(! _.has(item ,'approvedPwdReqForAdvEvidences')){
                    item['approvedPwdReqForAdvEvidences'] ="No";
                  }
                 
                  item['restrictPermDraftByAdvConfig'] ="No"


                }

                if(item['code'] === "PREPARE_PERM_APPLICATION"  ){
                  if(! _.has(item ,'restrictPermDraftByAdvConfig')){
                    item['restrictPermDraftByAdvConfig'] ="No";
                  }
                
                }
                //PREPARE_PERM_APPLICATION prepar only after 30 days of last adver 
                 
                if(item['code'] ==='SUPERVISOR_LIST' ||  item['code'] ==='ATTORNEY_LIST' ){
                  let createJobDes = _.find(this.finalActivity ,{'code':'CREATE_JOB_DESC'} );
                  let isitPermProcess = _.find(this.finalActivity ,{'code':'UPDATE_DOL_RESPONSE'} );
                  if(isitPermProcess && createJobDes){
                    item['actionRequired'] ="No";
                   item['include'] ="No";
                   item['editors'] =[];
                   item['watchers'] =[];

                  }

                }

                if(['INTERNAL_APPROVE_JOB_DESC'].indexOf(item['code'] >-1)){
                  item['optional'] = true;
                }



                finalActivity.push(item);

              });

            
            let postData ={"name":this.newform.name ,workflowType:this.newform.workflowType,"config":finalActivity};
            if( ([1].indexOf(this.getUserRoleId)>-1) && (this.selectedTenant && _.has(this.selectedTenant ,"_id"))){
              postData = Object.assign(postData ,{"tenantId":this.selectedTenant['_id']});
            }
              //tplTypeId: Number, // 1, H1B 2. H4 3. I-140 4. I-485 5. RFE


            postData['name'] = postData['name'].trim();
            if(this.checkProperty(this.selectedTemplate,'tplTypeId') ){
              postData['tplTypeId'] = parseInt(this.selectedTemplate['tplTypeId']);
              
              if([1].indexOf(this.checkProperty(this.selectedTemplate,'tplTypeId')) >-1 ){
                postData['manageRfeCase']='with_in_case'
                
              }
            }
            this.creatingWorkFlow =true;
            this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/workflow/create"})
              .then(response => {

                 this.creatingWorkFlow =false;
                
                 this.showToster({message:response.message,isError:false });
                 this.getList();
                 this.addPopup =false;
                 this.createNew(false);
                 setTimeout(() => {
                     this.editMe(response);
                     //this.$router.push("/workflow-config/"+response['_id']);
                 }, 10);
               
                
              })
              .catch((error)=>{
                 this.creatingWorkFlow =false;
                Object.assign(this.formerrors, {
                    msg:error
                  });
              })
          }
        });
      },
      
      questionnaireFields() {
        
        const item ={
          page:1,
          perpage: 10000,
          category: "questionnaire_fields",
          
        };

        this.$store.dispatch("getMasterData", item).then(response => {
          this.allQuestionnairefields = response.list;
         //alert(JSON.stringify(response.list))
        });
      },
      
      set_filter: function () {

        // this.$refs["filter_menu"].dropdownVisible = false;
        document.body.classList.remove('scroll-hidden');
        this.final_selected_statusids = [];
        if (this.selected_statusids.length > 0) {
          this.final_selected_statusids = [];
          for (let ind = 0; ind < this.selected_statusids.length; ind++) {
            let current_index = this.selected_statusids[ind];
            this.final_selected_statusids.push(current_index["id"]);
          }
        }

        this.final_selected_config_completed_statusids = [];
        if (this.selected_config_completed_statusids.length > 0) {
          this.final_selected_config_completed_statusids = [];
          for (let ind = 0; ind < this.selected_config_completed_statusids.length; ind++) {
            let current_index = this.selected_config_completed_statusids[ind];
            this.final_selected_config_completed_statusids.push(current_index["id"]);
          }
        }
        
         this.final_active_statusids = [];
        if (this.selected_active_statusids.length > 0) {
          this.final_active_statusids = [];
          for (let ind = 0; ind < this.selected_active_statusids.length; ind++) {
            let current_index = this.selected_active_statusids[ind];
            this.final_active_statusids.push(current_index["id"]);
          }
        }
        this.finalFilteredTenants =[];
        if(this.filteredTenants.length>0) {
          this.finalFilteredTenants = _.map(this.filteredTenants, '_id');
        }
// alert(this.final_selected_config_completed_statusids)
       

       
        this.page =1;
        this.getList(true);
      },
      clear_filter: function () {
        this.searchtxt ='';
        this.filteredTenants =[];
         this.finalFilteredTenants =[];
         this.final_active_statusids = [];
         this.selected_active_statusids =[];
        // this.$refs["filter_menu"].dropdownVisible = false;
        document.body.classList.remove('scroll-hidden');
        this.selected_statusids = [];
        this.final_selected_statusids = [];
        this.final_selected_config_completed_statusids = [];
        this.selected_config_completed_statusids = [];
      
        this.date = "";
        this.date_range = [];
         this.selected_createdDateRange["startDate"] = "";
         this.selected_createdDateRange["endDate"] = "";
        this.getList();
      },
      pageNate(pageNum) {
        this.page = pageNum;
        this.getList();
      },
      
      deleteformandLetter( ){
        let post_data = {"formAndLetterId":this.selectedItem['_id'] }
        this.$store.dispatch("deleteformandLetter", post_data)
          .then(response => {
           this.approveConformpopUp = false;
            this.showToster({message:response.message,isError:false});
            this.getList();
            this.edit =false;


          }).catch((er)=>{
            this.showToster({message:er,isError:true});
          
        });
      },

    },
    mounted() {
      this.getenants();
      this.getPetitionTypeList();
      this.getActivityList();
      this.selected_statusids = [];
      this.final_selected_statusids = [];
      this.seleted_states = [];
      this.final_selected_states = [];
 this.sortKeys = {
      
      'createdByName':1,
      "createdOn":-1,
      "updatedOn":1,
      createdByName:1,
      'name':1,
      tenantName:1,
      configCompleted:1,
      status:1,
      
     
    },

    this.sortKey = {"path":"createdOn" ,"order":-1};

    if(localStorage.getItem('workflow_sort_key') && localStorage.getItem('petitiin_sort_value')  && localStorage.getItem('petitiin_sort_value') >=-1 ){
       this.sortKey = {};

      this.sortKey[localStorage.getItem('workflow_sort_key')] = parseInt(localStorage.getItem('petitiin_sort_value'));
      this.sortKeys[localStorage.getItem('workflow_sort_key')] = this.sortKey[localStorage.getItem('workflow_sort_key')];

      //alert();

    }
    if(localStorage.getItem('formandLetter_perpage')){
        this.perpage = parseInt(localStorage.getItem('formandLetter_perpage'));
    }
     
      //this.questionnaireFields();
      this.getList();
     

    }
  };
</script>
